import { useEffect } from "react"

import { useUserActivity } from "./useUserActivity"

import { useAuthStore } from "@/stores/authStore"
import { checkAuthStatus } from "@/utils/auth"

const INACTIVITY_LOGOUT_TIMEOUT = 30 * 60 * 1000

export function useBackgroundTokenCheck(): void {
  const { isActive } = useUserActivity()
  const { tokens, signOut } = useAuthStore()

  useEffect(() => {
    if (!tokens.accessToken || !tokens.refreshToken) {
      return
    }

    if (isActive) {
      checkAuthStatus()
      return
    }

    const timeout = setTimeout(() => {
      void signOut()
    }, INACTIVITY_LOGOUT_TIMEOUT)

    return () => clearTimeout(timeout)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive, tokens.accessToken, tokens.refreshToken])
}
